/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-21 14:38:49
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-09-09 11:32:59
 */
import { asyncRoutes, constantRoutes, asyncRoutesEN } from '@/router'
import { setRoutesSort } from '@/utils/routes'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission (roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes (routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: setRoutesSort(constantRoutes),
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = setRoutesSort(routes)
    state.routes = setRoutesSort(constantRoutes.concat(routes))
  }
}

const actions = {
  setRoutes ({ commit }, roles) {
    commit('SET_ROUTES', roles)
  },
  generateRoutes ({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes
      // if (roles.includes('admin')) {
      if (roles === 'en') {
        accessedRoutes = asyncRoutesEN || []
      } else {
        accessedRoutes = asyncRoutes || []
        // accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      }
      const routes = setRoutesSort(accessedRoutes)
      commit('SET_ROUTES', accessedRoutes)
      resolve(routes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
